import C7Init from "./commerce7/c7";
import Modules from "./modules/modules";

new C7Init().init();
new Modules().init();

jQuery(document).ready(function($) {
    jQuery(".mobile-hamburger").on("click", function() {
        jQuery(".mobile-side-menu").toggleClass("hidden");
        jQuery("body").toggleClass("scroll-disabled");
    })
    jQuery(".close-side-menu").on("click", function() {
        jQuery(".mobile-side-menu").toggleClass("hidden");
        jQuery("body").toggleClass("scroll-disabled");
    })
    jQuery(".mobile-side-menu .menu-item-has-children").each(function(index) {
		jQuery(this).append("<div class='show-sub-menu'></div>")
        jQuery(".mobile-side-menu .sub-menu").slideUp(0);
	})
    jQuery(".mobile-side-menu .show-sub-menu").on("click", function() {
        if (jQuery(this).parent().hasClass("opened")) {
            jQuery(this).prev().slideUp(500);
        } else {
            jQuery(this).prev().slideDown(500);
        }
        jQuery(this).parent().toggleClass("opened")
	})

    const checkFooter = () => {
        const windowHeight = jQuery(window).height();
        const contentHeight = jQuery("body").height();
        const footerHeight = jQuery("footer").height();

        if (jQuery("footer").hasClass("sticky")) {
            if (windowHeight < (contentHeight + footerHeight)) {
                jQuery("footer").removeClass("sticky");
            }
        } else {
            if (windowHeight > contentHeight) {
                jQuery("footer").addClass("sticky");
            }
        }
    }

    if (jQuery("#c7-content").length == 0) {
        checkFooter();
    }

    jQuery(window).resize( function() {
        checkFooter();
    });

    jQuery(document).on('scroll', function() {
        const offset = jQuery("header").data("position");
        if (offset <= jQuery(this).scrollTop()) {
            if ( ! jQuery("header").hasClass("sticky") ) {
                jQuery("header").addClass("sticky")
            }
        } else {
            if ( jQuery("header").hasClass("sticky") ) {
                jQuery("header").removeClass("sticky")
            }
        }
    });

    // C7 Reservation PopUp
    jQuery(".hwy__banner-callout .c7-reserve").on("click", function() {
        jQuery(this).next().removeClass("d-none");
    })

    jQuery(".hwy__banner-callout .close-popup").on("click", function() {
        jQuery(this).closest(".c7-reservation-popup").addClass("d-none")
    })
});